import { FC } from 'react';
import styled from 'styled-components';
import { CollapsibleContent } from 'ui/collapsibleContent';
import { colors, spacing } from 'ui/theme';
import { useBranchFocusContext } from '../context/BranchFocusContext';
import { NestedTableBranchProps } from '../types';
import { Leaf } from './Leaf';

type BranchContainerProps = {
  isActive: boolean;
};

const BranchContainer = styled.div<BranchContainerProps>`
  min-width: fit-content;
  border: ${({ isActive }) => (isActive ? `${spacing.single} solid ${colors.purple50}` : 'none')};
`;

export const Branch: FC<React.PropsWithChildren<NestedTableBranchProps>> = ({
  isCollapsed,
  children,
  row,
  depth = 0,
  path,
  color,
}) => {
  const { activeBranch, setActiveBranch, showBranchFocus } = useBranchFocusContext();
  const isActive = showBranchFocus && path === activeBranch;
  const handleBranchSelection = () => {
    if (depth === 1) {
      setActiveBranch(path || '');
    }
  };

  return (
    <BranchContainer
      className="nested-branch"
      data-test="nested-table-branch"
      onClick={handleBranchSelection}
      isActive={isActive}
    >
      <Leaf value={row} color={color} path={path} depth={depth} isActive={isActive} />
      <CollapsibleContent isCollapsed={isCollapsed}>{children}</CollapsibleContent>
    </BranchContainer>
  );
};
